module.exports = __webpack_public_path__ + "media/images/common/menu_bottoms-47182a184be0794ba410e5aee6038b17.gif";